import React from 'react';
import { SLA_BARVA } from '../tiketyConst';
import { formatHodiny } from '../ui';

export function slaText(sla) {
  if (!sla || !sla.indikator) return null;
  switch (sla.indikator) {
    case 'zelena':    return 'V termínu';
    case 'oranzova':  return `Zbývá ${formatHodiny(sla.zbyva_h)}`;
    case 'cervena':   return 'Překročeno';
    case 'seda':      return 'Pozastaveno';
    case 'splneno':   return 'Splněno';
    case 'nesplneno': return 'Nesplněno';
    default:          return null;
  }
}

export default function SlaIndikator({ sla }) {
  const text = slaText(sla);
  if (!text) return <span style={{ color: '#9ca3af' }}>—</span>;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', whiteSpace: 'nowrap' }}>
      <span style={{ width: '12px', height: '12px', borderRadius: '50%', background: SLA_BARVA[sla.indikator], display: 'inline-block' }} />
      {text}
    </span>
  );
}
